import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { FindHttpError } from '../error/find-http-error';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class SimCardService {
  private static SIM_CARD_END_POINT = '/simCard';

  private BY_ICC_AND_NOT_ASSOCIATED = `${SimCardService.SIM_CARD_END_POINT}/findByContainningIccidAndNotAssociated`;

  private AVAILABLE_SIM_CARDS_BY_ICCID = `${SimCardService.SIM_CARD_END_POINT}/findAvailableSimCardsWithAccessByIccidContains`;

  find$: Observable<any>;
  error$: Observable<any>;

  private findSubject: Subject<any>;
  private errorSubject: Subject<any>;

  constructor(private _httpService: HttpService) {
    this.findSubject = new Subject();
    this.find$ = this.findSubject.asObservable();
    this.errorSubject = new Subject();
    this.error$ = this.errorSubject.asObservable();
  }

  findByContainningIccidAndNotAssociated(iccid) {
      this.getSimCardsByIccid(iccid, this.BY_ICC_AND_NOT_ASSOCIATED);
  }

  findAvailableSimCardsWithAccessByIccidContains(iccid) {
      this.getSimCardsByIccid(iccid, this.AVAILABLE_SIM_CARDS_BY_ICCID);
  }

  getSimCardsByIccid(iccid, url) {
    this._httpService.get(`${url}/${iccid}`, Array, FindHttpError)
      .subscribe(
        simCards => this.findSubject.next(simCards),
        error => this.errorSubject.next(error)
      );
  }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/shared/service/sim-card.service.ts